import React, { useEffect, useRef, useState } from 'react';
import { Button, Grid } from '@mui/material';
import { GridSortModel, GridPaginationModel } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import './PairingPackage.scss';
import { Link, useLocation } from 'react-router-dom';
import EditTableColumn from '../../components/EditTableColumn/EditTableColumn';
import { SearchBar } from '../../components/SearchBar/SearchBar';
import { useProfile } from '../../providers/Profile';
import { SearchStateInterface } from '../../models/SearchInterface';
import {
  datesNumToName,
  datesNameToNum,
  generatePrevNMonths,
  checkPrevMonthSelection,
  getFormattedMonth
} from '../../helpers/dateHelpers';
import { dates as monthsShort } from '../../constants/dates';
import { usePairingPackage } from '../../providers/PairingPackage';
import { useGeneralPairing } from '../../providers/GeneralPairing';
import Loader from '../../components/Loader/Loader';
import SlideDrawer from '../../components/SlideDrawer/SlideDrawer';
import Backdrop from '../../components/SlideDrawer/Backdrop';
import { usePairingById } from '../../providers/PairingById';
import { Pairing } from '../../models/PairingInterface';
import { useColumnPresets } from '../../providers/ColumnPresets';
import AddOrRemoveMyList from '../../components/PairingPackage/AddOrRemoveMyList';
import DetailView from '../../components/DetailView/DetailView';
import { generateColumns } from '../../helpers/tableHelpers';
import { useFreezePeriod } from '../../providers/FreezePeriod';
import GridDataLegend from '../../components/GridDataLegend/GridDataLegend';
import { capitalizeFirstLetter } from '../../helpers/commonHelpers';
import {
  filterPairingPackageData,
  pairingPackageInitialFilter
} from './pairingPackageHelper';
import { FreezePeriodInterface } from '../../models/FreezePeriodInterface';
import {
  appliedFilters,
  initialChangedFilters
} from '../SideFilterDrawer/filterHelper';
import { dates, months } from '../../constants/dates';
import { pushSiteInfo, registerPageInfo } from '../../helpers/analyticsHelper';
import { useAuth } from '../../providers/Auth';
import { useFilterPreference } from '../../providers/FilterPreference';
import { useNotifications } from '../../providers/Notifications';
import { getTwoDigits } from '../../components/SpecialDayOff/SpecialDayOffHelper';
import AcBackToTopButton from '../../components/AcBackToTopButton/AcBackToTopButton';
import { DataGridPro, GridPagination } from '@mui/x-data-grid-pro';
import {
  getNumDigits,
  initializeState,
  showAllRows
} from '../../helpers/viewAllHelper';

export default function PairingPackage() {
  const { t } = useTranslation();
  const filtersContext = useFilterPreference();
  const profileContext = useProfile();
  const [searchVisibility, setSearchVisibility] = useState(false);
  const [selectedPairingId, setSelectedPairingId] = useState('');
  const pairingContext = usePairingPackage();
  const generalPairingContext = useGeneralPairing();
  const pairingByIdContext = usePairingById();
  const columnPresetsContext = useColumnPresets();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const freezePeriodContext = useFreezePeriod();
  const location = useLocation();
  const [searchState, setSearchState] = useState<SearchStateInterface>({
    selectedDate: '',
    selectedBase: '',
    selectedEquipment: '',
    selectedPosition: ''
  });
  const [defaultSearchState, setDefaultSearchState] =
    useState<SearchStateInterface>({
      selectedDate: '',
      selectedBase: '',
      selectedEquipment: '',
      selectedPosition: ''
    });
  const [notificationVisible, setNotificationVisible] = useState({
    visible: false,
    updateMsg: ''
  });

  const [selectedFilters, setSelectedFilters] = useState(
    pairingPackageInitialFilter()
  );
  const [changedFilters, setChangedFilters] = useState(initialChangedFilters());
  const defaultDate = new Date();
  const [pairingList, setPairingList] = useState<Pairing>({
    pairingList: [],
    blockdates: { start: defaultDate, end: defaultDate }
  });
  const [colVisibility, setColVisibility] = useState({});
  const [xGridColumns, setXGridColumns] = useState<any>([]);
  const [formatedDate, setFormatedDate] = useState('');
  const [freezeStatus, setFreezeStatus] = useState<string | null>('');
  const [sortModel, setSortModel] = React.useState<GridSortModel>([]);
  // const [filterData, setFilterData] = useState(false);
  const [currentPairingMonthData, setCurrentPairingMonthData] =
    useState<FreezePeriodInterface>();
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState([25, 50, 100]);
  const [viewAllClicked, setViewAllClicked] = useState(false);
  // const [page, setPage] = useState(0);
  const [priorSelectedPairingId, setPriorSelectedPairingId] = useState('');
  const selectedPairingIdRef = useRef('');
  selectedPairingIdRef.current = selectedPairingId;
  const [saveFilters, setSaveFilters] = useState(false);
  const NotificationsContext = useNotifications();
  const [loading, setLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 25
  });
  const [dateOptions, setDateOptions] = useState<string[]>([]);

  useEffect(() => {
    if (
      !freezePeriodContext.freezePeriodData.pairingFreeze ||
      freezePeriodContext.loading
    ) {
      return;
    }
    setCurrentPairingMonthData({
      ...freezePeriodContext.freezePeriodData.pairingFreeze.filter(
        (val) => val
      )[0]
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [freezePeriodContext]);

  useEffect(() => {
    if (!searchState.selectedDate) {
      return;
    }
    if (!currentPairingMonthData) {
      setFreezeStatus('pairingPackage.noData');
      return;
    }
    let month = searchState.selectedDate.split(' ')[0]; // NOV 2021 -> NOV
    /// index returns data for any given month
    // in month is not found we set -1 and assume bidding is closed;
    // let index = freezePeriodContext.freezePeriodData.pairingFreeze.map((f,i, a) => f.pairingMonth === datesNameToNum(month) ? i : -1)[0];
    let index =
      currentPairingMonthData.pairingMonth === datesNameToNum(month) ? 0 : -1;

    if (index === -1) {
      setFreezeStatus('pairingPackage.stautsBiddingClosed');
      return;
    }
    // let freeze = freezePeriod(freezePeriodContext.freezePeriodData.pairingFreeze[index as number]);
    let pairingStatusFromApi =
      currentPairingMonthData.pairingStatus || 'noData';
    setFreezeStatus(t(`pairingStatus.${pairingStatusFromApi}`));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPairingMonthData, searchState.selectedDate]);

  useEffect(() => {
    if (!profileContext.profile.results || !currentPairingMonthData) {
      return;
    }

    let selectedDate = getFormattedMonth(currentPairingMonthData.pairingMonth, currentPairingMonthData.pairingYear);
    if (
      currentPairingMonthData &&
      currentPairingMonthData.dbmPosted === false
    ) {
      selectedDate = `${generatePrevNMonths(13, 2, new Date(currentPairingMonthData.pairingYear, currentPairingMonthData.pairingMonth - 1))[1].month} ${generatePrevNMonths(13, 2, new Date(currentPairingMonthData.pairingYear, currentPairingMonthData.pairingMonth - 1))[1].year}`
    }

    let pairingListMonth = '';
    if (
      location !== null &&
      location?.state !== null &&
      location?.state !== undefined
    ) {
      let { pairingListSearchState } = location.state;
      pairingListMonth = pairingListSearchState.selectedDate;
    }

    setDefaultSearchState({
      selectedDate: pairingListMonth || selectedDate,
      selectedBase: profileContext.profile.results?.baseLocation,
      selectedEquipment: profileContext.profile.results?.equipment,
      selectedPosition: profileContext.profile.results?.position
    });

    setSearchState({
      selectedDate: pairingListMonth || selectedDate,
      selectedBase: profileContext.profile.results?.baseLocation,
      selectedEquipment: profileContext.profile.results?.equipment,
      selectedPosition: profileContext.profile.results?.position
    });

    setDateOptions(concatDateName());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileContext.profile.results, currentPairingMonthData]);

  useEffect(() => {
    if (!searchState.selectedDate || !searchState.selectedPosition) {
      return;
    }
    generalPairingContext.getList(searchState);
    pairingContext.getPairingPackageData(searchState);

    let date = searchState.selectedDate.split(' ');
    let monthNumber = datesNameToNum(date[0]);
    setFormatedDate(
      `${date[1]}-${monthNumber && monthNumber < 10 ? '0' + monthNumber : monthNumber}-01T00:00:00`
    );

    setChangedFilters(initialChangedFilters());
    if (
      searchState.selectedBase ===
        profileContext.profile.results?.baseLocation &&
      searchState.selectedEquipment ===
        profileContext.profile.results?.equipment &&
      searchState.selectedPosition === profileContext.profile.results?.position
    ) {
      const selectedDate = {
        month:
          monthsShort.findIndex(
            (month) => month === searchState.selectedDate.split(' ')[0]
          ) + 1,
        year: Number(searchState.selectedDate.split(' ')[1])
      };
      filtersContext.getFilterPreferenceData(selectedDate);
      filtersContext.setSearchState(true);
      NotificationsContext.getNotifications();
    } else {
      setSelectedFilters(pairingPackageInitialFilter());
      filtersContext.setSearchState(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState]);

  useEffect(() => {
    if (!pairingContext.pairingPackageData) {
      return;
    }
    let filteredPairingList = filterPairingPackageData(
      pairingContext.pairingPackageData.pairingList,
      selectedFilters
    );
    appliedFilters(
      pairingContext.pairingPackageData.pairingList,
      selectedFilters,
      setChangedFilters,
      changedFilters
    );
    setPairingList((prevState) => {
      return {
        ...prevState,
        pairingList: filteredPairingList
      };
    });
    // setFilterData(false);

    //When display Filters is clicked, save the Filters after OtherFilters so that the API is called once, not 4 times
    if (saveFilters) {
      const selectedDate = {
        month:
          monthsShort.findIndex(
            (month) => month === searchState.selectedDate.split(' ')[0]
          ) + 1,
        year: Number(searchState.selectedDate.split(' ')[1])
      };
      filtersContext.saveFilterPreferenceData(selectedFilters, selectedDate);
      setSaveFilters(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pairingContext.pairingPackageData, selectedFilters]);

  useEffect(() => {
    if (!selectedPairingId) {
      return;
    }
    pairingByIdContext.getPairingDataById(selectedPairingId, searchState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPairingId, searchState]);

  const concatDateName = () => {
    if(!currentPairingMonthData) return generatePrevNMonths(13, 3).map(f => `${f.month} ${f.year}`);
    return generatePrevNMonths(
      13, 2, new Date(currentPairingMonthData.pairingYear, currentPairingMonthData.pairingMonth - 1)).map(f => `${f.month} ${f.year}`);
  };

  useEffect(() => {
    if (!columnPresetsContext.columnPreferences.columns || !colVisibility) {
      return;
    }
    let temp = {};
    columnPresetsContext.columnPreferences.columns.forEach((obj) => {
      temp[obj.internalCode] = obj.preferredDisplay;
    });
    if (columnPresetsContext.columnPreferences.sortOrder)
      handleSortChange(columnPresetsContext.columnPreferences.sortOrder);
    setColVisibility({ ...temp });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnPresetsContext.columnPreferences.columns]);

  useEffect(() => {
    if (!columnPresetsContext.columnPreferences.columns) {
      return;
    }
    const renderCells = {
      pairingId: (params) => (
        <span
          onClick={(e) => handleDetailView(params.row.pairingId, e)}
          className="pairing-id link-states"
        >
          {params.row.pairingId}
        </span>
      ),
      actions: (params) => (
        <div>
          <AddOrRemoveMyList
            search={searchState}
            categoryname={params.row.categoryname}
            pairingId={params.row.pairingId}
            handleRemove={() => {
              removeFavorite(
                params.row.categoryname,
                params.row.categoryid,
                params.row.pairingId
              );
            }}
          />
        </div>
      )
    };
    setXGridColumns(
      generateColumns(
        renderCells,
        t,
        'customActionLabel',
        searchState.selectedDate,
        dateOptions
      )
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState]);

  useEffect(() => {
    if (Object.keys(filtersContext.filterPreferenceData).length === 0) return;
    setSelectedFilters(filtersContext.filterPreferenceData);
  }, [filtersContext.filterPreferenceData]);

  const toggleNewSearch = () => {
    setSearchVisibility((prev) => !prev);
    handleSnapClose();
  };

  const handleDetailView = (id, event) => {
    setPriorSelectedPairingId(selectedPairingIdRef.current);
    setSelectedPairingId(id);
    setAnchorEl(event.currentTarget);
  };

  const handleSnapClose = () => {
    setSelectedPairingId('');
    setAnchorEl(null);
  };

  /**
   * Prevent the clickAway function from firing after handleDetailView when a user clicks on a different Pairing ID while a DetailView is already open
   * If user clicks on the same Pairing ID, close the DetailView
   */
  const handleDetailViewClickAway = (event) => {
    setSelectedPairingId('');
    if (event.target.className === 'pairing-id') {
      if (event.target.innerText === priorSelectedPairingId) setAnchorEl(null);
    } else {
      setAnchorEl(null);
    }
  };

  const [isToggle, setToggle] = useState(false);
  const toggleDrawer = () => {
    setToggle(!isToggle);
    handleSnapClose();
  };
  let backDrop;

  const toggleBackDrop = () => {
    setToggle(false);
  };

  if (isToggle) {
    backDrop = <Backdrop close={toggleBackDrop} />;
  }

  const CustomNoRowsOverlay = () => {
    return (
      <div className="no-rows">
        <i className="icon-error-warning error-icon" />
        <div>
          <p>{t('pairingPackage.noDataPara1')}</p>
          <p>{t('pairingPackage.noDataPara2')}</p>
        </div>
      </div>
    );
  };

  const removeFavorite = async (
    categoryName: string,
    categoryId: string,
    pairingId: string
  ) => {
    if (!categoryName || !categoryId || !pairingId) {
      return;
    }
    await generalPairingContext.removePairing(
      categoryName,
      categoryId,
      searchState,
      pairingId
    );
    generalPairingContext.getList(searchState);
    pairingContext.getPairingPackageData(searchState);
  };

  useEffect(() => {
    initializeState(
      paginationModel,
      setPaginationModel,
      setRowsPerPageOptions,
      viewAllClicked,
      pairingList.pairingList.length
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pairingList.pairingList, viewAllClicked]);

  const getAppliedFiltersCount = () => {
    let changed = 0;
    for (let k1 in changedFilters) {
      for (let k2 in changedFilters[k1]) {
        if (changedFilters[k1][k2] === true) {
          changed++;
        }
      }
    }
    return changed;
  };

  const clearFilters = () => {
    setChangedFilters(initialChangedFilters());
    setSelectedFilters(pairingPackageInitialFilter());
    if (filtersContext.defaultSearchState) setSaveFilters(true);
  };

  const handlePageSizeChange = (paginationModel) => {
    setPaginationModel(paginationModel);
    handleSnapClose();
    if (paginationModel.pageSize > 100) {
      setViewAllClicked(true);
    } else {
      setViewAllClicked(false);
    }
  };

  const user = useAuth();

  useEffect(() => {
    if (user.loading) return;

    if (!profileContext.profile.results) {
      return;
    }

    pushSiteInfo(user.user, profileContext.profile);

    registerPageInfo('my access app|planning & bidding|pairing package', {
      level1: 'my access app',
      level2: 'planning & bidding',
      level3: 'pairing package',
      level4: null
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, profileContext.profile.results]);

  useEffect(() => {
    if (!NotificationsContext?.notifications?.result) {
      return;
    }
    if (NotificationsContext?.notifications?.result?.length >= 1) {
      NotificationsContext.notifications.result.forEach((msg) => {
        if (msg.module === 'pairing.updated') {
          setNotificationVisible({
            visible: true,
            updateMsg: msg.message.description
          });
          NotificationsContext.updateNotificationViewed(
            msg.year,
            msg.month,
            'pairing.updated',
            msg.notificationId
          );
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [NotificationsContext.notifications]);

  /**
   * handleSortChange function is fired immediately when DataGrid is loaded which is unintentionally calling the saveSortPreference API.
   * Not wanted because we only want the saveSortPreference API to be fired when user clicks on column header,
   */
  let saveSort: boolean = false;
  const handleSortChange = (model) => {
    setSortModel(model);
    if (saveSort) columnPresetsContext.saveSortPreferenceData(model);
    setLoading(false);
  };

  /**
   * Will enable saveSort variable and allow the saveSortPreference API to be fired when user clicks on column header
   */
  const handleColumnClick = () => (saveSort = true);

  return (
    <section className="pairing-wrapper">
      {profileContext.loading ||
      pairingContext.loading ||
      filtersContext.loading ||
      columnPresetsContext.loading ||
      loading ? (
        <Loader />
      ) : (
        <>
          <SlideDrawer
            changedFilters={changedFilters}
            selectedDate={formatedDate}
            selectedFilters={selectedFilters}
            show={isToggle}
            setChangedFilters={setChangedFilters}
            // setFilterData={setFilterData}
            setPairingList={setPairingList}
            setSaveFilters={setSaveFilters}
            setSelectedFilters={setSelectedFilters}
            setToggle={setToggle}
          />
          {backDrop}
          <div className="pairing-package-header-container">
            <div className="header-grey header-content">
              <h1>{t('pairingPackage.title')}</h1>
              {!searchVisibility ? (
                <>
                  <div className="sub-title">
                    <span>{searchState.selectedDate}</span>
                    {searchState.selectedBase.toLowerCase() === 'all' ? (
                      <span>{t('SearchBar.allbases')}</span>
                    ) : (
                      <span>{searchState.selectedBase}</span>
                    )}
                    <span>{searchState.selectedEquipment}</span>
                    {searchState.selectedPosition.toLowerCase() === 'all' ? (
                      <span>{t('SearchBar.allpos')}</span>
                    ) : (
                      <span>{searchState.selectedPosition}</span>
                    )}
                  </div>
                  <span
                    className="new-search-link link-states"
                    onClick={toggleNewSearch}
                  >
                    <i className="icon-manage_accounts_FILL0_wght400_GRAD0_opsz48-1-1 change-position-icon" />
                    {t('pairingPackage.newSearch')}
                  </span>
                </>
              ) : (
                <div className="new-search-form">
                  <SearchBar
                    dateOptions={dateOptions}
                    includeDateField={true}
                    showAll={false}
                    defaultSearchState={defaultSearchState}
                    setSearchState={setSearchState}
                    setSearchVisibility={setSearchVisibility}
                    searchState={searchState}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="pairing-package-data-container">
            <AcBackToTopButton />
            <div className="toolbar-container toolbar-content">
              <Grid container>
                <Grid item className="left-block">
                  <span>
                    {t('pairingPackage.lastUpdate')}:{' '}
                    {pairingContext.pairingPackageData.lastUpdated
                      ? `${datesNumToName(new Date(pairingContext.pairingPackageData.lastUpdated).getMonth(), 1)} ${getTwoDigits(new Date(pairingContext.pairingPackageData.lastUpdated).getDate())}`
                      : t('pairingPackage.notApplicable')}
                  </span>
                  <span>
                    {t('pairingPackage.status')}:{' '}
                    {t(freezeStatus ?? 'pairingStatus.noData')}
                  </span>
                  <div className="dbm-mbg">
                    <Link to="/dbm">
                      {t('pairingPackage.dbm')} ={' '}
                      {capitalizeFirstLetter(
                        pairingContext.pairingPackageData.dbm
                      )}
                    </Link>
                    <Link to="/dbm">
                      {t('pairingPackage.mbg')} ={' '}
                      {capitalizeFirstLetter(
                        pairingContext.pairingPackageData.mbg
                      )}
                    </Link>
                  </div>
                  {('' + pairingContext.pairingPackageData.dbm === 'multiple' ||
                    '' + pairingContext.pairingPackageData.mbg ===
                      'multiple') && (
                    <div className="note-for-multiple">
                      {t('pairingPackage.selectSpecificPosition')}
                    </div>
                  )}
                </Grid>
                <Grid item sm />
                <Grid item className="right-block">
                  <EditTableColumn
                    presetDropdownOptions={
                      columnPresetsContext.columnPresets.presetNames
                    }
                    xGridColumns={xGridColumns}
                    colVisibility={colVisibility}
                    setColVisibility={setColVisibility}
                    setLoading={setLoading}
                  />
                  {pairingContext?.pairingPackageData?.pairingList.length >
                  0 ? (
                    <Button className="btn-black" onClick={toggleDrawer}>
                      <span className="icon-filter filterIcon"></span>{' '}
                      {t('pairingPackage.filters')}
                    </Button>
                  ) : (
                    ''
                  )}
                  <Grid item xs={12} />
                  {checkPrevMonthSelection(searchState.selectedDate, dateOptions) ? (
                    ''
                  ) : (
                    <Link
                      to={{
                        pathname: '/pairing-list',
                        state: { 
                          pairingPackageSelectedDate: searchState.selectedDate,
                          pairingPackageToDate: searchState.selectedDate === dateOptions[0] ? dateOptions[1] : dateOptions[0]
                        }
                      }}
                      className="pairing-list-link"
                    >
                      {t('pairingPackage.myPairingList')}{' '}
                      {
                        months[
                          dates.indexOf(searchState.selectedDate.split(' ')[0])
                        ]
                      }{' '}
                      <span className="icon-list"></span>
                    </Link>
                  )}
                </Grid>
              </Grid>
              {notificationVisible.visible ? (
                <div className="notification">
                  {' '}
                  <i className="icon-circle-flight"></i>
                  {notificationVisible.updateMsg}
                </div>
              ) : (
                ''
              )}
              <div className="multisort-instruction">
                {t('dbm.multiSortInstruction')}
              </div>
              <div className="no-of-results">
                {t('pairingPackage.results')}: {pairingList.pairingList.length}
                {getAppliedFiltersCount() > 0 ? (
                  <span>
                    {t('pairingPackage.of')}{' '}
                    {pairingContext.pairingPackageData.pairingList.length}{' '}
                    {t('pairingPackage.pairings')} ({getAppliedFiltersCount()}{' '}
                    {getAppliedFiltersCount() === 1
                      ? t('pairingPackage.filterApplied')
                      : t('pairingPackage.filtersApplied')}
                    ){' '}
                    <span onClick={clearFilters} className="clear-filter">
                      {t('pairingPackage.clearFilters')}
                    </span>{' '}
                    <span onClick={clearFilters} className="icon-close-light" />
                  </span>
                ) : (
                  t('pairingPackage.pairings')
                )}
              </div>
            </div>
            <div className="pairing-package-table dbm-report-table table-content">
              <DataGridPro
                autoHeight
                disableRowSelectionOnClick
                slots={{
                  noRowsOverlay: CustomNoRowsOverlay,
                  pagination: (props: any) => (
                    <>
                      <div
                        style={{ top: '-1rem' }}
                        className={`view-all-${getNumDigits(paginationModel.pageSize)}`}
                      >
                        {paginationModel.pageSize <
                        pairingList.pairingList.length ? (
                          <div className="enabled-view-all">
                            <span
                              onClick={() =>
                                showAllRows(
                                  setViewAllClicked,
                                  pairingList.pairingList.length,
                                  paginationModel,
                                  setPaginationModel
                                )
                              }
                            >
                              View All
                            </span>
                          </div>
                        ) : pairingList.pairingList.length > 10 ? (
                          <div className="disabled-view-all">
                            <span>View All</span>
                          </div>
                        ) : (
                          <div className="disabled-view-all-adjusted">
                            <span>View All</span>
                          </div>
                        )}
                      </div>
                      <GridPagination />
                    </>
                  )
                }}
                disableColumnMenu
                // disableSelectionOnClick
                // disableExtendRowFullWidth={true}
                paginationModel={paginationModel}
                onPaginationModelChange={handlePageSizeChange}
                // pageSize={pageSize}
                onColumnHeaderClick={() => handleColumnClick()}
                // onPageSizeChange={(newPageSize) => handlePageSizeChange(newPageSize)}
                pageSizeOptions={rowsPerPageOptions}
                pagination
                //rowsPerPageOptions={rowsPerPageOptions}
                rows={pairingList.pairingList}
                getRowId={(r) => r.pairingId}
                columns={xGridColumns}
                columnVisibilityModel={colVisibility}
                sortModel={sortModel}
                onSortModelChange={(model) => handleSortChange(model)}
                // page={page}
                // onPageChange={(page, details) => { setPage(page); handleSnapClose(); }}
              />
            </div>
          </div>
          <DetailView
            searchState={searchState}
            anchorEl={anchorEl}
            selectedPairingId={selectedPairingId}
            handleSnapClose={handleSnapClose}
            handleDetailViewClickAway={handleDetailViewClickAway}
          />
          <GridDataLegend />
        </>
      )}
    </section>
  );
}
